import { createReducer, on } from '@ngrx/store';
import * as fromAccountActions from '../actions/account.action';
export const featureKey = 'account';

export interface State {
    userProfle: any,
    scorers: {
        data: Array<any>,
        isLoaded: Boolean
    };
    players: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    userProfle: null,
    scorers: {
        data: [],
        isLoaded: false
    },
    players: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromAccountActions.getUserProfileSuccess, (state: State, props: any) => ({
        ...state,
        userProfle: props.data
    })),
    on(fromAccountActions.getScorersSuccess, (state: State, props: any) => ({
        ...state,
        scorers: { data: props.data, isLoaded: true },
    })),
    on(fromAccountActions.getPlayersSuccess, (state: State, props: any) => ({
        ...state,
        players: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);